import { motion, useInView } from "framer-motion";
import React, { useRef } from "react";

/* ═══════════════════════════════════════════════════════════
   SVG Logo Icons — Top Banner Technologies
   ═══════════════════════════════════════════════════════════ */

const AWSLogo = ({ className }) => (
  <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 62L32 26L46 62" stroke="currentColor" strokeWidth="5" strokeLinejoin="round" strokeLinecap="round" fill="none" />
    <path d="M24 48H40" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
    <path d="M55 62L65 30L75 62" stroke="currentColor" strokeWidth="5" strokeLinejoin="round" strokeLinecap="round" fill="none" />
    <path d="M59 48H71" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
    <path d="M14 74C14 74 32 82 50 74C68 66 86 74 86 74" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
  </svg>
);
const AzureLogo = ({ className }) => (
  <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M25 80L45 20H55L40 55L75 80H25Z" stroke="currentColor" strokeWidth="4.5" fill="none" strokeLinejoin="round" />
    <path d="M55 20L80 55" stroke="currentColor" strokeWidth="4.5" strokeLinecap="round" />
  </svg>
);
const NodeLogo = ({ className }) => (
  <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M50 6L93 31V69L50 94L7 69V31L50 6Z" stroke="currentColor" strokeWidth="5" fill="none" strokeLinejoin="round" />
    <path d="M50 24V52" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
    <path d="M50 52L34 64" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
    <path d="M50 52L66 64" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
  </svg>
);
const DotNetLogo = ({ className }) => (
  <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="38" stroke="currentColor" strokeWidth="5" fill="none" />
    <circle cx="30" cy="62" r="5" fill="currentColor" />
    <path d="M42 65V35L58 65V35" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M68 35V65" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
    <path d="M62 42H74" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
  </svg>
);
const FastAPILogo = ({ className }) => (
  <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M50 8L90 50L50 92L10 50L50 8Z" stroke="currentColor" strokeWidth="5" fill="none" strokeLinejoin="round" />
    <path d="M50 28V50L38 72" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M50 50L62 72" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
  </svg>
);
const PythonLogo = ({ className }) => (
  <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M50 10C35 10 30 18 30 26V38H50V42H22C22 42 10 40 10 58C10 76 20 78 28 78H38V66C38 66 37 56 48 56H68C68 56 78 57 78 46V26C78 26 80 10 50 10Z" stroke="currentColor" strokeWidth="4.5" fill="none" strokeLinejoin="round" />
    <circle cx="40" cy="24" r="4" fill="currentColor" />
    <circle cx="60" cy="72" r="4" fill="currentColor" />
  </svg>
);
const ReactLogo = ({ className }) => (
  <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="8" fill="currentColor" />
    <ellipse cx="50" cy="50" rx="44" ry="17" stroke="currentColor" strokeWidth="4.5" fill="none" />
    <ellipse cx="50" cy="50" rx="44" ry="17" stroke="currentColor" strokeWidth="4.5" fill="none" transform="rotate(60 50 50)" />
    <ellipse cx="50" cy="50" rx="44" ry="17" stroke="currentColor" strokeWidth="4.5" fill="none" transform="rotate(120 50 50)" />
  </svg>
);
const PostgresLogo = ({ className }) => (
  <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="50" cy="28" rx="28" ry="16" stroke="currentColor" strokeWidth="4.5" fill="none" />
    <path d="M22 28V72" stroke="currentColor" strokeWidth="4.5" strokeLinecap="round" />
    <path d="M78 28V72" stroke="currentColor" strokeWidth="4.5" strokeLinecap="round" />
    <ellipse cx="50" cy="72" rx="28" ry="16" stroke="currentColor" strokeWidth="4.5" fill="none" />
    <path d="M22 50H78" stroke="currentColor" strokeWidth="3" strokeDasharray="4 4" />
  </svg>
);
const DockerLogo = ({ className }) => (
  <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="10" y="50" width="72" height="28" rx="7" stroke="currentColor" strokeWidth="5" fill="none" />
    <rect x="18" y="35" width="15" height="15" rx="3" stroke="currentColor" strokeWidth="4" fill="none" />
    <rect x="40" y="35" width="15" height="15" rx="3" stroke="currentColor" strokeWidth="4" fill="none" />
    <rect x="40" y="14" width="15" height="15" rx="3" stroke="currentColor" strokeWidth="4" fill="none" />
    <rect x="62" y="35" width="15" height="15" rx="3" stroke="currentColor" strokeWidth="4" fill="none" />
    <path d="M86 55C92 43 82 37 76 39" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    <circle cx="38" cy="64" r="4" fill="currentColor" />
    <circle cx="55" cy="64" r="4" fill="currentColor" />
  </svg>
);
const VectorDBLogo = ({ className }) => (
  <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="25" r="8" stroke="currentColor" strokeWidth="4" fill="none" />
    <circle cx="25" cy="70" r="8" stroke="currentColor" strokeWidth="4" fill="none" />
    <circle cx="75" cy="70" r="8" stroke="currentColor" strokeWidth="4" fill="none" />
    <circle cx="50" cy="55" r="6" stroke="currentColor" strokeWidth="3.5" fill="none" />
    <path d="M50 33V49" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path d="M44 57L31 66" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path d="M56 57L69 66" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path d="M50 25L25 70" stroke="currentColor" strokeWidth="2" strokeDasharray="4 4" opacity="0.4" />
    <path d="M50 25L75 70" stroke="currentColor" strokeWidth="2" strokeDasharray="4 4" opacity="0.4" />
    <path d="M25 70L75 70" stroke="currentColor" strokeWidth="2" strokeDasharray="4 4" opacity="0.4" />
  </svg>
);

/* ═══════════════════════════════════════════════════════════
   Data — Top Banner & Category Cards
   ═══════════════════════════════════════════════════════════ */

const LOGO_STRIP = [
  { Logo: AWSLogo, name: "AWS" },
  { Logo: AzureLogo, name: "Azure" },
  { Logo: NodeLogo, name: "Node.js" },
  { Logo: DotNetLogo, name: "ASP.NET" },
  { Logo: FastAPILogo, name: "FastAPI" },
  { Logo: PythonLogo, name: "Python" },
  { Logo: ReactLogo, name: "React" },
  { Logo: PostgresLogo, name: "PostgreSQL" },
  { Logo: DockerLogo, name: "Docker" },
  { Logo: VectorDBLogo, name: "Vector DBs" },
];

const CATEGORIES = [
  {
    title: "AI Systems & Intelligent Automations",
    Logo: VectorDBLogo,
    techs: [
      { name: "Custom AI Agents & Web Assistants", highlight: true },
      { name: "RAG Systems", highlight: true },
      { name: "Vector DBs (Pinecone, Qdrant, ChromaDB, pgvector)", highlight: true },
      { name: "LLM Integration & Workflow Automation", highlight: false },
      { name: "LangChain / LlamaIndex", highlight: false },
    ],
  },
  {
    title: "Backend & Enterprise Frameworks",
    Logo: FastAPILogo,
    techs: [
      { name: "FastAPI (Python)", highlight: true },
      { name: "Node.js (Express)", highlight: true },
      { name: "ASP.NET Core / C#", highlight: true },
      { name: "RESTful APIs & GraphQL", highlight: false },
      { name: "Microservices Architecture", highlight: false },
    ],
  },
  {
    title: "Cloud Infrastructure & DevOps",
    Logo: AWSLogo,
    techs: [
      { name: "Amazon Web Services (AWS)", highlight: true },
      { name: "Microsoft Azure", highlight: true },
      { name: "Google Cloud Platform (GCP)", highlight: true },
      { name: "DigitalOcean", highlight: false },
      { name: "Docker & Containerization", highlight: false },
      { name: "CI/CD Pipelines & Vercel", highlight: false },
      { name: "Linux Administration", highlight: false },
    ],
  },
  {
    title: "Frontend Engineering",
    Logo: ReactLogo,
    techs: [
      { name: "Next.js & React", highlight: true },
      { name: "TypeScript", highlight: true },
      { name: "Tailwind CSS", highlight: true },
      { name: "Redux / Modern State Management", highlight: false },
    ],
  },
  {
    title: "Databases & Storage",
    Logo: PostgresLogo,
    techs: [
      { name: "PostgreSQL / pgvector", highlight: true },
      { name: "MongoDB", highlight: true },
      { name: "Redis (Caching)", highlight: true },
      { name: "SQL Server", highlight: false },
    ],
  },
];

/* ═══════════════════════════════════════════════════════════
   Helper Components
   ═══════════════════════════════════════════════════════════ */

function TechBadge({ name, highlight }) {
  return (
    <span
      className={`inline-flex items-center px-3 py-1.5 sm:px-3.5 sm:py-2 rounded-xl text-[11px] sm:text-xs font-bold border transition-colors cursor-default
      ${
        highlight
          ? "bg-primary/10 text-primary border-primary/30 shadow-sm"
          : "bg-background/80 text-foreground border-border hover:bg-primary/5 hover:text-primary hover:border-primary/20"
      }`}
    >
      {name}
    </span>
  );
}

function LogoChip({ Logo, name, delay, isInView }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.4, delay }}
      className="group flex flex-col items-center justify-center gap-2 sm:gap-3 py-4 sm:py-5 px-2 rounded-2xl min-w-0
        glass-card shadow-sm
        hover:border-primary/40 hover:-translate-y-1 hover:shadow-glow
        transition-all duration-300 cursor-default select-none"
    >
      <Logo className="w-8 h-8 text-muted-foreground group-hover:text-primary transition-colors duration-300" />
      <span className="text-[10px] sm:text-[11px] font-bold text-muted-foreground group-hover:text-foreground transition-colors duration-300 leading-none text-center break-words">
        {name}
      </span>
    </motion.div>
  );
}

/* ═══════════════════════════════════════════════════════════
   Skills Section
   ═══════════════════════════════════════════════════════════ */

const Skills = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section
      id="skills"
      ref={ref}
      className="relative py-20 md:py-28 lg:py-32 px-4 sm:px-5 md:px-10 lg:px-12 bg-secondary/30"
    >
      <div className="max-w-6xl mx-auto relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="text-center mb-12 sm:mb-16"
        >
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background border border-border text-xs font-semibold mb-6 tracking-widest uppercase text-muted-foreground">
            Technical Stack
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-4 tracking-tight">
            Engineering & AI Capabilities
          </h2>
          <p className="text-muted-foreground text-base max-w-2xl mx-auto leading-relaxed">
            Enterprise software engineering, modern cloud infrastructure, and custom AI systems — from high-performance FastAPIs and Vector DBs to production RAG agents.
          </p>
        </motion.div>

        {/* Top Icon Banner — 10 High-Value Technologies */}
        <div className="grid grid-cols-3 min-[420px]:grid-cols-4 sm:grid-cols-5 md:grid-cols-10 gap-2 sm:gap-3 mb-10 sm:mb-14">
          {LOGO_STRIP.map((item, i) => (
            <LogoChip key={item.name} {...item} delay={0.1 + 0.04 * i} isInView={isInView} />
          ))}
        </div>

        {/* Category Cards — 5-Card / 2-Row Responsive Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {CATEGORIES.map((cat, i) => (
            <motion.div
              key={cat.title}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.15 + i * 0.08 }}
              className={`group relative rounded-2xl sm:rounded-3xl p-5 sm:p-7 flex flex-col gap-4 sm:gap-5 glass-card transition-all duration-300 cursor-default min-w-0 ${
                i >= 3 ? "lg:col-span-1" : ""
              }`}
            >
              <div className="flex items-center gap-3 sm:gap-4 min-w-0">
                <div className="w-12 h-12 rounded-2xl bg-primary/10 border border-primary/20 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <cat.Logo className="w-6 h-6 text-primary" />
                </div>
                <div className="min-w-0">
                  <h3 className="font-heading font-bold text-base sm:text-lg text-foreground tracking-tight group-hover:text-primary transition-colors leading-tight">
                    {cat.title}
                  </h3>
                </div>
              </div>
              <div className="flex flex-wrap gap-1.5 sm:gap-2">
                {cat.techs.map((t) => (
                  <TechBadge key={t.name} name={t.name} highlight={t.highlight} />
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
